import PropTypes from "prop-types";
import React from "react";

import { FieldValueWrapper, isFieldValueWrapper } from "@elastic/react-search-ui-views/lib/types/FieldValueWrapper";
import { getUrlSanitizer } from "@elastic/react-search-ui-views/lib/view-helpers/getUrlSanitizer";
function getFieldType(result, field, type) {
    if (result[field]) return result[field][type];
  }
  
  function getRaw(result, field) {
    return getFieldType(result, field, "raw");
  }
  
  function getSnippet(result, field) {
    return getFieldType(result, field, "snippet");
  }
  
  function htmlEscape(str) {
    if (!str) return "";
  
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
  
  function getEscapedField(result, field) {
    // Fallback to raw values here, because non-string fields
    // will not have a snippet fallback. Raw values MUST be html escaped.
    const safeField =
      getSnippet(result, field) || htmlEscape(getRaw(result, field));
    return Array.isArray(safeField) ? safeField.join(", ") : safeField;
  }
  
  function getEscapedFields(result) {
    return Object.keys(result).reduce((acc, field) => {
      // If we receive an arbitrary value from the response, we may not properly
      // handle it, so we should filter out arbitrary values here.
      //
      // I.e.,
      // Arbitrary value: "_metaField: '1939191'"
      // vs.
      // FieldValueWrapper: "_metaField: {raw: '1939191'}"
      if (!isFieldValueWrapper(result[field])) return acc; 
      return { ...acc, [field]: getEscapedField(result, field) };
    }, {});
  }

  function Result({
    className,
    result,
    onClickLink,
    titleField,
    urlField,
    ...rest
  }) {

    const fields = getEscapedFields(result);
    const title = getEscapedField(result, titleField);
    //TODO: location undefined? const url = getUrlSanitizer(URL, location)(getRaw(result, urlField));
    const url = (getRaw(result, urlField));

    return (
        <li className="sui-result">
        <div className="sui-result__header">
            {title && !url && (
                <span
                    className="sui-result__title"
                    // Snippeted results contain search term highlights with html and are
                    // 100% safe and santitized, so we dangerously set them here
                    dangerouslySetInnerHTML={{ __html: result.name.snippet }}
                />
          )}
            {title && url && (
            <a
                className="sui-result__title sui-result__title-link"
                dangerouslySetInnerHTML={{ __html: title }}
                href={url}
                onClick={onClickLink}
                target="_blank"
                rel="noopener noreferrer"
            />
            )}
        </div>
        <div className="sui-result__body">
          <div
            className="sui-result__image"
            style={{
              maxWidth: "140px",
              paddingLeft: "24px",
              paddingTop: "10px"
            }}
          >
            <img
              src={result.image_url.raw}
              alt="thumb"
              style={{
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center"
              }}
            />
          </div>
          <ul className="sui-result__details">
            <li>
              <span className="sui-result__key">Genre</span>{" "}
              <span
                className="sui-result__value"
                dangerouslySetInnerHTML={{
                  __html: result.genre.snippet
                }}
              />
            </li>
            <li>
              <span className="sui-result__key">Publisher</span>{" "}
              <span
                className="sui-result__value"
                dangerouslySetInnerHTML={{
                  __html: result.publisher.snippet
                }}
              />
            </li>
            <li>
              <span className="sui-result__key">Critic Score</span>{" "}
              <span className="sui-result__value">{result.critic_score.raw}</span>
            </li>
            <li>
              <span className="sui-result__key">User Score</span>{" "}
              <span className="sui-result__value">{result.user_score.raw}</span>
            </li>
            <li>
              <span className="sui-result__key">Platform</span>{" "}
              <span
                className="sui-result__value"
                dangerouslySetInnerHTML={{
                  __html: result.platform.snippet
                }}
              />
            </li>
          </ul>
        </div>
      </li>
    );
  }

  export default Result;

